import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs } from "../mock";

export default function FAQSection() {
  return (
    <section id="faq" className="relative py-20 md:py-28">
      <div className="relative mx-auto max-w-4xl px-5">
        <div className="text-center reveal">
          <span className="kicker">Questions fréquentes</span>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white mt-3">
            Tu as encore des{" "}
            <span className="gold-gradient-text">questions</span> ?
          </h2>
        </div>

        <div className="mt-12 reveal">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="glass rounded-2xl px-6 border-white/10"
              >
                <AccordionTrigger className="text-left text-white hover:text-gold hover:no-underline font-display text-lg py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/65 leading-relaxed pb-5 text-[15px]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
